
import wencai from "@/views/textGenerate/images/wencai.svg";
import fengge from "@/views/textGenerate/images/fengge.svg";
import suoxie from "@/views/textGenerate/images/suoxie.svg";
import xiuzheng from "@/views/textGenerate/images/xiuzheng.svg";
import jianlian from "@/views/textGenerate/images/jianlian.svg";
import jieshi from "@/views/textGenerate/images/jieshi.svg";
import zongjie from "@/views/textGenerate/images/zongjie.svg";
import fanyi from "@/views/textGenerate/images/fanyi.svg";
import gaixie from "@/views/textGenerate/images/gaixie.svg";
import wencaigrey from "@/views/textGenerate/images/wencai_grey.svg";
import fenggegrey from "@/views/textGenerate/images/fengge_grey.svg";
import suoxiegrey from "@/views/textGenerate/images/suoxie_grey.svg";
import xiuzhenggrey from "@/views/textGenerate/images/xiuzheng_grey.svg";
import jianliangrey from "@/views/textGenerate/images/jianlian_grey.svg";
import jieshigrey from "@/views/textGenerate/images/jieshi_grey.svg";
import zongjiegrey from "@/views/textGenerate/images/zongjie_grey.svg";
import fanyigrey from "@/views/textGenerate/images/fanyi_grey.svg";
import gaixiegrey from "@/views/textGenerate/images/gaixie_grey.svg";

export const FUN_DATA = [
    {
        text: "同义改写",
        Icon: gaixie,
        IconGrey: gaixiegrey,
        id: '8',
        template_name: "synonymous_rewriting",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "synonymous_rewriting",
                "previous_chat": prevChat,
                "post_process":{"punc_conv":true},
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "文采提升",
        Icon: wencai,
        IconGrey: wencaigrey,
        id: '0',
        template_name: "literary_talent",
        limit:true,
        template: function({
            prevChat,
            textReplace = '',
            language = ''
        }){
            return {
                "template_name": "literary_talent",
                "previous_chat": prevChat,
                "post_process":{"punc_conv":true},
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "风格改写",
        Icon: fengge,
        IconGrey: fenggegrey,
        id: '1',
        subTitle: "请选择改写的风格",
        desc: "可选9种风格",
        template_name: "article_transform",
        limit:true,
        subInfos: [
            { text: "短视频", id: '1_0' },
            { text: "鲁迅", id: '1_1' },
            { text: "胡锡进", id: '1_2' },
            { text: "自由幽默", id: '1_3' },
            { text: "诙谐讽刺", id: '1_4' },
            { text: "夸张搞笑", id: '1_5' },
            { text: "抒情细腻", id: '1_6' },
            { text: "专业正式", id: '1_7' },
            { text: "老练直白", id: '1_8' },
            { text: "华丽典雅", id: '1_9' }
        ],
        template: ({
            prevChat,
            textReplace = '',
            destination = '',
            language = ''
        }) => {
            return {
                "template_name": "article_transform",
                "previous_chat": prevChat,
                "post_process":{"punc_conv":true},
                "input_para": {
                    "result_count": 1,
                    "article_text": textReplace,
                    "transform_style": destination,
                    language
                }
            }
        }
    },
    {
        text: "缩写",
        Icon: suoxie,
        IconGrey: suoxiegrey,
        id: '2',
        template_name: "content_abridge",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "content_abridge",
                "previous_chat": prevChat,
                "post_process":{"punc_conv":true},
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "修正拼写和语法错误",
        Icon: xiuzheng,
        IconGrey: xiuzhenggrey,
        id: '3',
        template_name: "error_recovery",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "error_recovery",
                "previous_chat": prevChat,
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }

    },
    {
        text: "简练语言",
        Icon: jianlian,
        IconGrey: jianliangrey,
        id: '4',
        template_name: "simplify_language",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "simplify_language",
                "previous_chat": prevChat,
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "解释",
        Icon: jieshi,
        IconGrey: jieshigrey,
        id: '5',
        template_name: "content_interpretate",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "content_interpretate",
                "previous_chat": prevChat,
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "总结",
        Icon: zongjie,
        IconGrey: zongjiegrey,
        id: '6',
        template_name: "content_summary",
        limit:false,
        template: ({
            prevChat,
            textReplace = '',
            language = ''
        }) => {
            return {
                "template_name": "content_summary",
                "previous_chat": prevChat,
                "input_para": {
                    "result_count": 1,
                    "content": textReplace,
                    language
                }
            }
        }
    },
    {
        text: "翻译",
        Icon: fanyi,
        IconGrey: fanyigrey,
        id: '7',
        subTitle: "请选择翻译的语种",
        desc: "可选14种语言",
        template_name: "translator",
        limit:false,
        subInfos: [
            { text: "英语", id: "7_0" },
            { text: "中文", id: '7_1' },
            { text: "韩语", id: '7_2' },
            { text: "日语", id: '7_3' },
            { text: "西班牙语", id: '7_4' },
            { text: "俄语", id: '7_5' },
            { text: "法语", id: '7_6' },
            { text: "葡萄牙语", id: '7_7' },
            { text: "德语", id: '7_8' },
            { text: "意大利语", id: '7_9' },
            { text: "荷兰语", id: '7_10' },
            { text: "印地语", id: '7_11' },
            { text: "菲律宾语", id: '7_12' },
            { text: "越南语", id: '7_13' },

        ],
        template: ({
            prevChat,
            textReplace = '',
            destination = '',
            language = ''
        }) => {
            return {
                "template_name": "translator",
                "previous_chat": prevChat,
                "input_para": {
                    "result_count": 1,
                    destination,
                    language,
                    "content": textReplace
                }
            }
        }
    }
    
];